import { render, staticRenderFns } from "./DescriptionBar.vue?vue&type=template&id=0829b98b&scoped=true&"
import script from "./DescriptionBar.vue?vue&type=script&lang=ts&"
export * from "./DescriptionBar.vue?vue&type=script&lang=ts&"
import style0 from "./DescriptionBar.vue?vue&type=style&index=0&id=0829b98b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0829b98b",
  null
  
)

export default component.exports